import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success(`¡Bienvenido de vuelta, ${res.user.name}!`);
      navigate("/", { replace: true });
    } else {
      setError(res.error);
    }
  };

  const fillDemo = () => {
    setEmail("demo@fiper.app");
    setPassword("demo123");
  };

  return (
    <div className="fp-shell fp-grain" data-testid="login-screen">
      <div className="relative z-10 px-6 pt-10 pb-10 min-h-screen flex flex-col">
        <Link
          to="/welcome"
          data-testid="login-back-link"
          className="inline-flex items-center gap-1 text-soft hover:text-ink text-sm w-fit"
        >
          <ArrowLeft size={16} /> Volver
        </Link>

        <div className="mt-12 animate-fade-up">
          <img
            src="/branding/logo-horizontal-400.png"
            srcSet="/branding/logo-horizontal-400.png 1x, /branding/logo-horizontal-800.png 2x"
            alt="FiPer"
            width="106"
            height="60"
            className="h-10 w-auto mb-5 select-none"
            data-testid="login-brand-logo"
            draggable="false"
          />
          <h1 className="mt-2 font-display text-4xl font-extrabold tracking-tight">
            Bienvenido<br />de vuelta.
          </h1>
          <p className="mt-2 text-muted2">Inicia sesión para ver tu saldo real.</p>
        </div>

        <form onSubmit={handleSubmit} className="mt-10 space-y-6 flex-1">
          <div>
            <label className="text-[10px] font-bold uppercase tracking-[0.16em] text-sage-700 block mb-1">
              Email
            </label>
            <input
              data-testid="login-email-input"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@correo.com"
              className="w-full bg-transparent border-b-2 border-line py-3 text-lg outline-none focus:border-sage-500 transition-colors"
            />
          </div>
          <div>
            <label className="text-[10px] font-bold uppercase tracking-[0.16em] text-sage-700 block mb-1">
              Contraseña
            </label>
            <input
              data-testid="login-password-input"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="w-full bg-transparent border-b-2 border-line py-3 text-lg outline-none focus:border-sage-500 transition-colors"
            />
          </div>

          {error && (
            <p data-testid="login-error" className="text-sm text-clay bg-clay/5 border border-clay/20 rounded-xl px-3 py-2">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-button"
            className="w-full bg-sage-900 text-bone rounded-2xl py-4 font-bold hover:bg-sage-900/90 active:scale-[0.98] transition-all disabled:opacity-60"
          >
            {loading ? "Iniciando…" : "Iniciar sesión"}
          </button>

          <button
            type="button"
            onClick={fillDemo}
            data-testid="login-demo-button"
            className="w-full bg-white border border-line rounded-2xl py-3 text-sm text-ink hover:bg-sage-50 transition-colors"
          >
            Usar cuenta demo
          </button>
        </form>

        <p className="text-center text-sm text-muted2 mt-6">
          ¿Sin cuenta?{" "}
          <Link to="/register" data-testid="login-go-register" className="text-sage-900 font-bold">
            Crea una
          </Link>
        </p>
      </div>
    </div>
  );
}
